import React, { ReactElement } from "react";
import PlotlyChart from "react-plotlyjs-ts";

interface Props {
  data: {
    x: number;
    line: { color: string };
    name: string;
    type: string;
    [key: string]: any;
  }[];
}

export default function BoxPlots({ data }: Props): ReactElement {
  return (
    <div style={{ border: "solid 1px", borderRadius: "5px" }}>
      <PlotlyChart
        data={data}
        layout={{
          paper_bgcolor: "#eee",
          margin: {
            l: 40,
            r: 40,
            b: 40,
            t: 40,
          },
          yaxis: {
            showline: false,
            showgrid: false,
            autotick: false,
            ticklen: 0,
            tickwidth: 0,

            // ticks: "outside",
          },
          height: 200,
          showlegend: false,
        }}
      />
    </div>
  );
}
